import { useEffect, useRef } from 'react';

const END_OF_TEXT = -1;

interface UseCursorPositionOptions {
  autoFocus?: boolean;
  cursorPosition?: number;
  textLength?: number;
}

export function useCursorPosition(
  inputRef: React.RefObject<HTMLTextAreaElement | HTMLInputElement | null>,
  { autoFocus, cursorPosition, textLength = 0 }: UseCursorPositionOptions = {},
) {
  const previousCursorPosition = useRef<number | undefined>(undefined);

  useEffect(() => {
    if (!inputRef.current) {
      return;
    }

    const needsFocus = autoFocus && document.activeElement !== inputRef.current;
    if (needsFocus) {
      inputRef.current.focus();
    }

    const isCursorPositionChanged =
      previousCursorPosition.current !== cursorPosition;
    if (
      cursorPosition === undefined ||
      (!isCursorPositionChanged && !needsFocus)
    ) {
      return;
    }

    const targetPosition =
      cursorPosition === END_OF_TEXT
        ? textLength
        : Math.min(cursorPosition, textLength);
    inputRef.current.setSelectionRange(targetPosition, targetPosition);

    previousCursorPosition.current = cursorPosition;

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoFocus, cursorPosition, textLength]);
}
